import { Action, createReducer, on } from '@ngrx/store';

import { LoadMaintenanceInfoSuccess } from "../actions/maintenanceInfo.action";
import { initialStateMaintenanceInfo, MaintenanceInfo } from "../states/maintenanceInfo.state";

const changeMaintenanceInfoReducer = createReducer(
  initialStateMaintenanceInfo,
  on(LoadMaintenanceInfoSuccess, (_state, { maintenanceInfo }) => maintenanceInfo)
);


export function maintenanceInfoReducer(state: MaintenanceInfo, action: Action) {
  return changeMaintenanceInfoReducer(state, action);
}
